import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { CommentsComponentTypes } from "../SearchResultListItem/types";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { DefaultTheme } from "styled-components/native";

const CommentsComponent = ({ comments }: CommentsComponentTypes) => {
  const theme = useTheme();
  const typography = useTypographyStore();

  return (
    <CommentsContainer>
      <VDBText color={theme["core-06"]} type={typography["Minor-R"]}>
        Comments
      </VDBText>
      <Spacer size={SpaceType.ExtraSmall} />
      <VDBText color={theme["core-05"]} type={typography["Minor-M"]}>
        {comments}
      </VDBText>
    </CommentsContainer>
  );
};

const CommentsContainer = styled.View`
  flex_direction: column;
  justify-content: space-between;
  padding: ${SpaceType.Basic}px;
  width: auto;
  background-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["core-01"] as string};
  align-items: flex-start;
  justify-content: center;
  border-bottom-left-radius: ${SpaceType.Basic}px;
  border-bottom-right-radius: ${SpaceType.Basic}px;
`;

export default React.memo(CommentsComponent);
